import React from 'react';
import { Location } from 'history';
import { connect } from 'react-redux';
import { Header, Loader, IDropdownItem } from 'components';
import { SidebarContainer } from '../../containers';
import { IRootState, Dispatch } from '../../redux/store/configureStore';
import { useReloader } from 'hooks';
import { getUserAuthTokens } from '../../helpers/UserAuthTokens';
import { setHeaderTitle, setAuthToken, getAuthToken } from '_helpers';
import { push } from 'connected-react-router';
import styles from './AuthorizedLayout.module.scss';
import sidebarTabs from '../../routes/SidebarTabs';

const AuthorizedLayout = ({
                              children, location, auth, authProcessing, onPush,
                          }: Props) => {
    const reload = useReloader(location);

    const getDropdownItems = (): IDropdownItem[] | null => {
        const userAuthTokens = getUserAuthTokens();

        if (!userAuthTokens) return null;

        return userAuthTokens.map(e => ({
            label: e.name || '-',
            active: e.token === getAuthToken(),
            onClick: () => {
                if (e.token) {
                    setHeaderTitle(e.name || '-');
                    setAuthToken(e.token);
                    onPush('/');
                }
            },
        }));
    };

    return (
      <div className="wrapper">
          <SidebarContainer />
          <div className="main-panel">
              <Header
                location={location}
                tabs={sidebarTabs}
                dropdownItems={getDropdownItems()}
                role={auth ? auth.profile.status : undefined}
              />
              {reload ? null : (
                <div data-test-authorized-content className={styles.content}>
                    {children}
                </div>
              )}
          </div>
          {authProcessing && (!auth || (auth && !auth.profile)) ? <Loader showBg /> : null}
      </div>
    );
};

const mapState = (state: IRootState) => ({
    auth: state.auth.auth,
    authProcessing: Boolean(state.loading.models.auth),
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
});

export default connect(mapState, mapDispatch)(AuthorizedLayout);

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

interface OwnProps {
    children: JSX.Element[] | JSX.Element;
    location: Location;
}

type Props = connectedProps & OwnProps;
